import { Navigate } from 'react-router';
import React from 'react';

import { all_routes } from './all_routes';
import AboutUs from '../pages/aboutus';
import BookingDetail from '../booking/booking-detail';
import BookingForm from '../booking/booking-form';
import BookingPayment from '../booking/booking-payment';
import BookingSuccess from '../booking/booking-success';
import ComingSoon from '../pages/comingsoon/comingsoon';
import Contact from '../contact/contact';
import Error404 from '../pages/errorpages/error404';
import Error500 from '../pages/errorpages/error500';
import Faq from '../pages/faq/faq';
import ForgotPassword from '../authentication/forgotpassword';
import Gallerys from '../pages/gallery';
import HomeOne from '../home/home-one/home-one';
import How from '../pages/how';
import ListingDetails from '../listings/listingDetails';
import ListingGrid from '../listings/listing-grid';
import Login from '../authentication/login';
import Maintenance from '../pages/maintenance/maintenance';
import PaymentCancel from '../payment/cancel';
import PaymentSuccess from '../payment/success';
import PaymentPending from '../booking/payment-pending';

import Pricing from '../pages/pricing';

import UserAgreement from '../pages/userAgreement';

import ResetPassword from '../authentication/resetpassword';
import SignUp from '../authentication/signup';
import Testimonials from '../pages/testimonial/testimonials';
import UserBookings from '../user/userbookings';
import UserPayment from '../user/userpayment';
import UserSettings from '../user/settings/usersettings';
import UserSecurity from '../user/usersecurity';

import PrivacyPolicy from '../pages/privacypolicy/privacypolicy';

import Why from '../pages/why';

const routes = all_routes;

export const publicRoutes = [
  {
    path: routes.homeOne,
    element: <HomeOne />,
  },
  {
    path: '/',
    element: <Navigate to="/index" />,
  },

  {
    path: '*',
    element: <Navigate to="/index" />,
  },

  {
    path: routes.contactUs,
    element: <Contact />,
  },

  {
    path: routes.paymentSuccess,
    element: <PaymentSuccess />,
  },

  {
    path: routes.paymentCancel,
    element: <PaymentCancel />,
  },
];

export const listingroutes = [
  {
    path: routes.listingGrid,
    element: <ListingGrid />,
  },

  {
    path: `${routes.listingDetails}/:vin`,
    element: <ListingDetails />,
  },
];

export const pageroutes = [
  {
    path: routes.aboutUs,
    element: <AboutUs />,
  },
  {
    path: routes.pricing,
    element: <Pricing />,
  },
  {
    path: routes.whyUs,
    element: <Why />,
  },
  {
    path: routes.howItWorks,
    element: <How />,
  },

  {
    path: routes.faq,
    element: <Faq />,
  },
  {
    path: routes.gallery,
    element: <Gallerys />,
  },
  {
    path: `${routes.bookingCheckout}/:vin`,
    element: <BookingForm />,
  },

  {
    path: routes.userAgreement,
    element: <UserAgreement />,
  },

  {
    path: routes.testimonial,
    element: <Testimonials />,
  },

  {
    path: routes.bookingDetail,
    element: <BookingDetail />,
  },
  {
    path: routes.bookingPayment,
    element: <BookingPayment />,
  },
  {
    path: `${routes.bookingSuccess}`,
    element: <BookingSuccess />,
  },

  {
    path: routes.paymentPending,
    element: <PaymentPending />,
  },

  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
  },
];

export const authenticationRoute = [
  {
    path: routes.register,
    element: <SignUp />,
  },
  {
    path: routes.login,
    element: <Login />,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
  },
  {
    path: routes.error404,
    element: <Error404 />,
  },
  {
    path: routes.error500,
    element: <Error500 />,
  },
  {
    path: routes.maintenance,
    element: <Maintenance />,
  },
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
  },
];

export const usermodule = [
  {
    path: routes.userSettings,
    element: <UserSettings />,
  },

  {
    path: routes.userSecurity,
    element: <UserSecurity />,
  },

  {
    path: routes.userPayment,
    element: <UserPayment />,
  },

  {
    path: routes.userBookings,
    element: <UserBookings />,
  },
];
